import React from 'react';
import RecorderV1 from 'components/organismos/RecorderV1';
import SidebarTemplate from 'components/templates/SidebarTemplate';

const RecorderPage_v1 = () => (
  <SidebarTemplate>
    <RecorderV1/>
  </SidebarTemplate>
);

export default RecorderPage_v1;
